var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 792,
    height: 350,
    viewBox: "0 0 792 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M789 173V173.5H789.5V173H789ZM786.333 3C786.333 4.47276 787.527 5.66667 789 5.66667C790.473 5.66667 791.667 4.47276 791.667 3C791.667 1.52724 790.473 0.333333 789 0.333333C787.527 0.333333 786.333 1.52724 786.333 3ZM510 173.5H789V172.5H510V173.5ZM789.5 173V3H788.5V173H789.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552 122V122.5H552.5V122H552ZM549.333 3C549.333 4.47276 550.527 5.66667 552 5.66667C553.473 5.66667 554.667 4.47276 554.667 3C554.667 1.52724 553.473 0.333333 552 0.333333C550.527 0.333333 549.333 1.52724 549.333 3ZM496 122.5H552V121.5H496V122.5ZM552.5 122V3H551.5V122H552.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238 122V122.5H237.5V122H238ZM240.667 3C240.667 4.47276 239.473 5.66667 238 5.66667C236.527 5.66667 235.333 4.47276 235.333 3C235.333 1.52724 236.527 0.333333 238 0.333333C239.473 0.333333 240.667 1.52724 240.667 3ZM294 122.5H238V121.5H294V122.5ZM237.5 122V3H238.5V122H237.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.667 346.5C398.667 345.027 397.473 343.833 396 343.833C394.527 343.833 393.333 345.027 393.333 346.5C393.333 347.973 394.527 349.167 396 349.167C397.473 349.167 398.667 347.973 398.667 346.5ZM395.5 287V346.5H396.5V287H395.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 173V173.5H2.5V173H3ZM5.66666 3C5.66666 4.47276 4.47275 5.66667 3 5.66667C1.52725 5.66667 0.333344 4.47276 0.333344 3C0.333344 1.52724 1.52725 0.333333 3 0.333333C4.47275 0.333333 5.66666 1.52724 5.66666 3ZM282 173.5H3V172.5H282V173.5ZM2.5 173V3H3.5V173H2.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.5 173C508.5 235.132 458.132 285.5 396 285.5C333.868 285.5 283.5 235.132 283.5 173C283.5 110.868 333.868 60.5 396 60.5C458.132 60.5 508.5 110.868 508.5 173Z",
    stroke: "#FB3505",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCom);
export default __webpack_public_path__ + "static/media/COM.70a3951ef765d09839a85a3e31febc3a.svg";
export { ForwardRef as ReactComponent };